<script>
	import { postSettings, bodyStyle, headerStyle, footerStyle, focusBox, allowTrans, activeTab, isSmall } from "./stores.js";
	import { colorAvg } from "./tools.js";

	import Textbox from "./components/Textbox.svelte";

	const layouts = ["single", "double", "double-alt", "triple"];


	let overlayStyle = "";
	let formatting;
	let gridW = 0;

	$: {
		overlayStyle = colorize($postSettings.isGrad);

		if ($postSettings.filter != "duotone") {
			overlayStyle += ` mix-blend-mode: ${$postSettings.blending};`
		}

		formatting = `align-${$postSettings.valign} ${layouts[$postSettings.fields]}`;
	}

	function colorize(isgrad) {
		let colstyle = "";

		if (isgrad) {
			let start = $postSettings.startCol;
			let end = $postSettings.endCol;
			let mid = colorAvg(start, end);
			let alpha = $postSettings.alpha;

			colstyle = `background-image: linear-gradient(${alpha+180}deg, ${start}, ${mid}, ${end});`;
		} else {
			colstyle = `background-color: ${$postSettings.startCol};`;
		}

		return colstyle;
	}

	function setOptions(event) {
		$focusBox = event.detail.name;

		if ($isSmall) {
			$activeTab = 2;
		}
	}

</script>

<div id="editor">
	<div id="background">
		{#if $postSettings.backdrop}
			<img class="{$postSettings.filter}" src="{$postSettings.backdrop}" alt="Post Background" />
		{/if}

		{#if $postSettings.filter == "duotone"}
			<div class="layer" id="duo-bottom" style:background-color={$postSettings.startCol}>&nbsp;</div>
			<div class="layer" id="duo-top" style:background-color={$postSettings.endCol}>&nbsp;</div>
		{:else}
			<div class="layer" id="color-overlay" style="{overlayStyle}" style:opacity={$allowTrans ? $postSettings.opacity : 1}>&nbsp;</div>
		{/if}
	</div>

	<div id="textgrid" class={formatting} bind:clientWidth={gridW}>
		<Textbox name="header" styler={$headerStyle} parentWidth={gridW} on:edit={setOptions} />
		<Textbox name="body" styler={$bodyStyle} parentWidth={gridW} on:edit={setOptions} />
		<Textbox name="footer" styler={$footerStyle} parentWidth={gridW} on:edit={setOptions} />

	</div>


</div>

<style>
	#editor {
		position: relative;
		width: clamp(20rem, 50vw, 75vh);
		aspect-ratio: 1;
		overflow: hidden;
	}

	#textgrid {
		display: grid;
		width: 100%;
		height: 100%;
		padding: 2.5%;
	}

	#background {
		position: absolute;
		inset: 0;
		z-index: -9;
		background-image: url('../img/dummy-bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}

	#background img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	#background img.duotone {
		filter: grayscale(1) brightness(110%);
	}

	#background img.grayscale {
		filter: grayscale(1) brightness(110%);
	}

	#background img.sepia {
		filter: sepia(1) brightness(90%);
	}

	#background img.warmup {
		filter: hue-rotate(-15deg) saturate(1.2);
	}

	#background img.cooldown {
		filter: hue-rotate(15deg) saturate(0.8);
	}

	#background img.hicontrast {
		filter: contrast(1.25);
	}

	#background img.saturate {
		filter: saturate(1.8);
	}

	#background div.layer {
		position: absolute;
		inset: 0;
	}

	#background #duo-bottom {
		mix-blend-mode: multiply;
	}

	#background #duo-top {
		mix-blend-mode: screen;
	}

	@media screen and (max-width: 720px) {
	  #editor {
	  	width: min(calc(100vw - 1rem), calc(50svh - 1rem));
	  }
	}
</style>
